if (!customElements.get('cart-shipping-estimator')) {
  customElements.define(
    'cart-shipping-estimator',
    class CartShippingEstimator extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.country = this.querySelector('[data-country]');
        this.province = this.querySelector('[data-province]');
        this.provinceField = this.querySelector('[data-province-field]');
        this.postalCode = this.querySelector('[data-postal-code]');
        this.submitButton = this.querySelector('[data-submit]');
        this.result = this.querySelector('[data-result]');

        if (!this.form || !this.country || !this.postalCode || !this.result) return;

        this.handleCountryChange = () => this.updateProvinces();
        this.handleSubmit = (event) => this.onSubmit(event);
        this.country.addEventListener('change', this.handleCountryChange);
        this.form.addEventListener('submit', this.handleSubmit);
        this.updateProvinces();
      }

      disconnectedCallback() {
        this.country?.removeEventListener('change', this.handleCountryChange);
        this.form?.removeEventListener('submit', this.handleSubmit);
      }

      updateProvinces() {
        const selectedCountry = this.country.selectedOptions[0];
        let provinces = [];

        try {
          provinces = JSON.parse(selectedCountry?.dataset.provinces || '[]');
        } catch (error) {
          provinces = [];
        }

        this.province.replaceChildren();
        provinces.forEach(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          this.province.append(option);
        });
        this.provinceField.hidden = provinces.length === 0;
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.form.reportValidity()) return;

        this.setLoading(true);
        this.result.hidden = true;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const url = new URL(`${root}cart/shipping_rates.json`, window.location.origin);
          url.searchParams.set('shipping_address[country]', this.country.value);
          url.searchParams.set('shipping_address[province]', this.provinceField.hidden ? '' : this.province.value);
          url.searchParams.set('shipping_address[zip]', this.postalCode.value.trim());

          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error(`Shipping rates request failed with ${response.status}`);

          const payload = await response.json();
          this.renderRates(payload.shipping_rates || []);
        } catch (error) {
          this.renderMessage(this.dataset.errorMessage);
        } finally {
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.submitButton.disabled = isLoading;
        this.submitButton.textContent = isLoading ? this.dataset.loadingLabel : this.dataset.submitLabel;
        this.setAttribute('aria-busy', String(isLoading));
      }

      renderRates(rates) {
        this.result.replaceChildren();

        if (rates.length === 0) {
          this.renderMessage(this.dataset.noRatesMessage);
          return;
        }

        const heading = document.createElement('p');
        heading.className = 'sdna-shipping-estimator__result-heading';
        heading.textContent = this.dataset.resultHeading.replace('__postal_code__', this.postalCode.value.trim());

        const list = document.createElement('ul');
        rates.slice(0, 4).forEach((rate) => {
          const item = document.createElement('li');
          const name = document.createElement('span');
          const price = document.createElement('strong');
          name.textContent = rate.presentment_name || rate.name;
          price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
            style: 'currency',
            currency: rate.currency,
          }).format(Number(rate.price));
          item.append(name, price);
          list.append(item);
        });

        this.result.append(heading, list);
        this.result.hidden = false;
      }

      renderMessage(message) {
        this.result.replaceChildren();
        const paragraph = document.createElement('p');
        paragraph.textContent = message;
        this.result.append(paragraph);
        this.result.hidden = false;
      }
    },
  );
}
